import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		ref,
		watch
	} from "vue";
	import bottomBar from "@/components/bottomBar.vue";
	import {
		useRouter,
		useRoute
	} from "vue-router";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const router = useRouter();
	const route = useRoute();
	
	document.title = '中概电力科技';

	watch(() => route.path, () => {
		document.body.scrollTop = 0
		document.documentElement.scrollTop = 0
	});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})